export default {
  index: 'Home Page ',
  summary: 'Application profile',
  studentQuery: "Student",
  applicationList: "Application",
  studentManagement: 'Student Management',
  studentRegister: 'New applicant',
  studentInfo: 'Personal Information of Students',
  studentInfoManagement: 'Student Information Management',
  studentApplicationForm: 'Student Application Summary',
  commissionManagement: 'Commission Management',
  informationCenter: 'Information Center',
  newsInfo: 'News Information',
  institutionInfo: 'Institutional Information',
  institutionInformationDetail: 'Institutional Information Details',
  videoCenter: 'Video Center',
  newsInfoEntrance: 'News information entrance',
  newsInfoDetail: 'News details',
  quickViewMPS: 'Quick View Commission',

  businessOverview: 'Business Overview',
  businessStatistics: 'Business Statistics',
  financialSettlement: 'Financial Settlement',
  mpsManagement: 'Commission',
  resourceManagement: 'Institutional Resources',
  applicationFee: 'University data information',
  languageReq: 'Accepted languages',
  companySetting: 'Company Setting',
  setting: 'Setting',
  studentInformation: 'Student Page',
  contactPerson: '+ New Login',
};
